@if(eventLinkOverride() === null) {
  <ng-container *ngTemplateOutlet="routerLinkCard"/>
}
@else {
  <ng-container *ngTemplateOutlet="hrefCard"/>
}

<ng-template #hrefCard>
  <a [href]="eventLinkOverride()">
    <ng-container *ngTemplateOutlet="card"/>
  </a>
</ng-template>

<ng-template #routerLinkCard>
  <a [routerLink]="eventWebRoute()">
    <ng-container *ngTemplateOutlet="card"/>
  </a>
</ng-template>

<ng-template #card>
  <div class="min-h-full flex flex-col rounded-2xl shadow-xl hover:shadow-2xl">
    <div class="relative">
      <img [src]="coverImage()" class="flex-initial aspect-cover w-full object-cover object-center rounded-t-2xl" [loading]="shouldLoadEagerly() ? 'eager' : 'lazy'" [alt]="name()">

      <div class="z-10 absolute top-0 right-0">
        @if(pricing() !== null) {
          <div class="bg-primary rounded-bl-2xl rounded-tr-2xl w-fit px-2 py-1">
            <span class="line-clamp-1 text-on-primary font-normal tracking-tightest text-white">{{ pricing() }}</span>
          </div>
        }
      </div>
    </div>

    <div class="flex-1 bg-white rounded-b-2xl px-2.5 pb-2.5 flex flex-col justify-start">
      <div>
        <h1 class="line-clamp-2 text-2xl text-default-light font-semibold tracking-tightest">{{name()}}</h1>
      </div>

      <div>
        <app-start-date [startDate]="event().startDate" [eventDateFormat]="event().eventDateFormat" [timezone]="timezone()"></app-start-date>
      </div>

      <div class="flex-1"></div>

      <div>
        <app-location-info [locationInfo]="event().locationInfo"></app-location-info>
      </div>
    </div>
  </div>
</ng-template>
